// extracted by mini-css-extract-plugin
export default {"varInfo":"VarItem_varInfo__a9eXP","varNum":"VarItem_varNum__4VNAm","varTitle":"VarItem_varTitle__5LtmC"};